import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { CaptionText } from '@paypalcorp/pp-react';
import { renderSwitchComponent } from '../../switchPanels/SwitchPanel';
import BasicInputField from '../../fields/BasicInputField';
import getLocaleMessages from '../../../utils/localesMessages';

const { title, subTitle, textInfo, textLabel } =
  getLocaleMessages('buttonsV3/note');

const renderNoteTextField = (props) => {
  return <BasicInputField {...props} />;
};

function Note({ isChecked, showBadge, dispatch }) {
  return (
    <div className="note">
      <Field
        id="isNoteEnabled"
        name="noNote"
        label="isNoteEnabled"
        title={title}
        subTitle={subTitle}
        component={renderSwitchComponent}
        isChecked={isChecked}
        reversed={true}
        showBadge={showBadge}
      />
      {isChecked ? (
        <>
          <Field
            id="noteLabel"
            name="noteLabel"
            type="text"
            component={renderNoteTextField}
            label={textLabel}
            validateOnChange={true}
          />
          <CaptionText className="note-info">{textInfo}</CaptionText>
        </>
      ) : null}
    </div>
  );
}

Note.propTypes = {
  isChecked: PropTypes.bool,
  dispatch: PropTypes.func,
  showBadge: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => {
  return { dispatch };
};

export default connect(null, mapDispatchToProps)(Note);
